export const ALL = 'ALL';
export const AMEX = 'AMEX';
export const DISCOVER = 'DISCOVER';
export const MA = 'MA';
export const MASTERCARD = 'MASTERCARD';
export const VISA = 'VISA';
//Default cryptoTypes
export const DTVV = 'DTVV';
export const TAVV = 'TAVV';

export const idReferences = {
  AMEX: 'amexSDK',
  DISCOVER: 'discoverSDK',
  MA: 'maSDK',
  VISA: 'visaSDK'
};

export const CRYPTO_TYPES = {
  AMEX: {
    DTVV,
    TAVV
  },
  DISCOVER: {
    DTVV: 'DYNAMIC_CARD_SECURITY_CODE',
    TAVV: 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM'
  },
  MA: {
    DTVV: 'CARD_SECURITY_CODE',
    TAVV: 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM'
  },
  VISA: {
    DTVV: 'DYNAMIC_CARD_SECURITY_CODE',
    TAVV: 'CARD_APPLICATION_CRYPTOGRAM_LONG_FORM'
  }
};
